export default __webpack_public_path__ + "static/media/brand-image-04.a1812f75.jpg";